export enum SignatureStatus {
  OPEN = 'OPEN',
  UNSIGNED = 'UNSIGNED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  SIGNATURE_RULE_MISSING = 'SIGNATURE_RULE_MISSING',
  FULLY_SIGNED = 'FULLY_SIGNED',
  UNSIGNED_NO_PERMISSION = 'UNSIGNED_NO_PERMISSION',
  PARTIALLY_SIGNED_NO_PERMISSION = 'PARTIALLY_SIGNED_NO_PERMISSION',
}
